import React from 'react';
import { Box, Chip, Typography, Paper } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  groupTitle: {
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  chipGroup: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  chip: {
    '&.MuiChip-root': {
      borderRadius: theme.shape.borderRadius,
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        transform: 'translateY(-1px)',
        boxShadow: theme.shadows[2],
      },
    },
  },
  selectedChip: {
    '&.MuiChip-root': {
      fontWeight: 600,
      transform: 'scale(1.05)',
      boxShadow: theme.shadows[3],
    },
  },
  selectedLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
}));

const ChipSelector = ({ groups, selectedReport, onSelect }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.root} elevation={0} variant="outlined">
      {Object.entries(groups).map(([groupName, reports]) => {
        const hasSelectedReport = reports.some(report => report.uuid === selectedReport?.uuid);
        
        return (
          <Box key={groupName} mb={3}>
            <Typography variant="subtitle1" className={classes.groupTitle}>
              {groupName}
              {hasSelectedReport && (
                <Typography variant="body2" className={classes.selectedLabel}>
                  <CheckCircleIcon fontSize="small" />
                  Selected report from this group
                </Typography>
              )}
            </Typography>
            <Box className={classes.chipGroup}>
              {reports.map((report) => {
                const isSelected = selectedReport?.uuid === report.uuid;
                return (
                  <Chip
                    key={report.uuid}
                    label={report.name}
                    onClick={() => onSelect(report)}
                    color={isSelected ? "primary" : "default"}
                    variant={isSelected ? "filled" : "outlined"}
                    className={`${classes.chip} ${isSelected ? classes.selectedChip : ''}`}
                    icon={isSelected ? <CheckCircleIcon /> : undefined}
                  />
                );
              })}
            </Box>
          </Box>
        );
      })}
    </Paper>
  );
};

export default ChipSelector;
